export default __webpack_public_path__ + "static/media/css3.3001f030.svg";